var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"transparent px-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":12,"sm":7}},[_c('personal-info')],1)],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }